import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'Messaggi email',
  labels: {
    view_full_message: 'Visualizza messaggio completo',
    status: 'Stato:',
    on: 'Attivo',
    off: 'Disattivo',
    next_send: 'Prossimo invio: {{date}}.',
  },
  descriptions: {
    welcome:
      'Inviata una sola volta quando un cliente si iscrive alle tue email di marketing, escluse le iscrizioni tramite il modulo del tuo storefront. Un cliente riceve solo una tra Benvenuto, Benvenuto nel club dei membri e Offerta di lancio.',
    welcome_members_club:
      'Inviata una sola volta quando qualcuno si iscrive tramite il modulo del tuo storefront e non è impostato alcun codice promo di iscrizione, oppure entra nella tua lista di membri VIP. Un cliente riceve solo una tra Benvenuto, Benvenuto nel club dei membri e Offerta di lancio.',
    storefront_promo:
      "Inviata una sola volta quando qualcuno si iscrive tramite il modulo del tuo storefront mentre è impostato un codice promo di iscrizione. L'email contiene il suo codice promo personale.",
    launch_deal:
      'Inviata una sola volta ai tuoi clienti importati, 30 minuti dopo che il tuo ristorante va online. I clienti che hanno già ricevuto Benvenuto o Benvenuto nel club dei membri vengono saltati.',
    we_miss_you:
      'Inviata agli iscritti il cui ultimo ordine risale a più di 45 giorni fa. Controllata ogni mattina; un cliente la riceve al massimo una volta ogni 45 giorni.',
    happy_friday:
      'Inviata a tutti gli iscritti alle 08:00 UTC il primo venerdì di ogni mese pari (febbraio, aprile, giugno, agosto, ottobre, dicembre).',
    lazy_sunday:
      'Inviata a tutti gli iscritti alle 08:00 UTC la prima domenica di ogni mese dispari (gennaio, marzo, maggio, luglio, settembre, novembre).',
    loyalty_program:
      "Inviata quando il saldo cashback di un cliente raggiunge l'importo minimo spendibile. Un cliente la riceve al massimo una volta ogni 30 giorni.",
    you_might_also_like:
      'Inviata 3 giorni dopo un ordine con almeno 2 dello stesso articolo dal prezzo di 6,00 o più, consigliando uno dei tuoi articoli più popolari. Un cliente la riceve al massimo una volta ogni 30 giorni.',
  },
  tiles: {
    sends_count: 'Messaggi inviati',
    delivery_rate: 'Tasso di consegna',
    delivered_suffix: 'consegnati',
    open_rate: 'Tasso di apertura',
    opened_suffix: 'aperti',
    click_rate: 'Tasso di clic',
    clicked_suffix: 'cliccati',
    spam_report_rate: 'Tasso di segnalazione spam',
    spam_reports_suffix: 'segnalazioni',
    unsubscribe_rate: 'Tasso di disiscrizione',
    unsubscribes_suffix: 'disiscrizioni',
  },
  toasts: {
    failed_to_update_status: 'Aggiornamento stato non riuscito',
    failed_to_load_data: 'Caricamento dati non riuscito',
  },

  preview_modal: {
    title: 'Anteprima template',
    labels: {
      subject: 'Oggetto:',
      close: 'Chiudi',
    },
    toasts: {
      failed_to_load_data: "Caricamento dell'anteprima non riuscito",
    },
    template_data: {
      recipient_name: '&lt;Nome&gt;',
    },
  },
};
